import {
    TitleBox,
    SnackBar,
    Header,
    useSnackBarContext,
    HorizontalRule,
} from '@tgg/ui';

import { StyledMain } from 'libs/ui/src/lib/components/Layout/Layout.styled';

import { JoinJourneyProgressBar } from '../JoinJourneyProgressBar';

import { JoinJourneyLayoutProperties } from './JoinJourneyLayout.types';

export function JoinJourneyLayout({
    children,
    title = 'Join The Gym Group',
    isRejoin = false,
}: JoinJourneyLayoutProperties) {
    const [{ content: snackBarContent, barType: snackBarType }] =
        useSnackBarContext();

    return (
        <div id="wrapper">
            <Header logoOnly />
            <StyledMain>
                <TitleBox text={title} />
                <JoinJourneyProgressBar isRejoin={isRejoin} />
                <HorizontalRule />
                {snackBarType !== 'none' && (
                    <SnackBar
                        message={snackBarContent}
                        barType={snackBarType}
                        iconName={
                            snackBarType === 'error' ? 'alert' : undefined
                        }
                    />
                )}
                {children}
            </StyledMain>
        </div>
    );
}
